import { Form } from 'react-bootstrap';
import './CustomDropdown.css';

const CustomDropdown = (props) => {
  const {
    label,
    placeholder,
    value,
    onChange,
    name,
    required,
    disabled,
    options = [],
    showError,
    errorMessage,
  } = props;

  const controlId = props.id || name || 'dropdown';
  const displayLabel = label || placeholder;

  return (
    <Form.Group className="dropdown-wrapper">
      <Form.Select
        className={`custom-dropdown ${showError ? 'invalid' : ''}`}
        value={value}
        onChange={onChange}
        name={name}
        required={required}
        disabled={disabled}
        aria-required={required}
        id={controlId}
        data-testid={controlId}
      >
        <option value="" disabled>
          {placeholder || 'Please select'}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      <Form.Label className="floating-label" htmlFor={controlId}>
        {displayLabel}
        {required && <span className="required-asterisk">*</span>}
      </Form.Label>
      {errorMessage && showError && (
        <Form.Control.Feedback
          type="invalid"
          className="form-dropdown-feedback-error"
          style={{
            padding: '0rem',
            display: 'block',
          }}
        >
          {errorMessage}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default CustomDropdown;
